export const FeesReadCoverageTypes = new Set([
    'Fees', 
    'Value Added Services'
]);

export const BenefitsReadCoverageTypes = new Set([
  'Misc Benefits',
  'Misc. Benefits',
  'Life & Disability',
  'Medical',
  'Dental',
  'Vision',
  'Vision Benefits',
]);